export const REVIEWS = [
    {
        translate: 'Translated from Russian',
        text: 'There is no point in writing a lot of words, it is just that with this key press it was possible to increase sales of even old works, replacing the keys that were once selected manually.',
        user: {
            name: 'Алексей',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Ukrainian',
        text: "After the shutter mixed up the words, and it became difficult to figure out where the words that sell and where the ones that don't - key selection became a much less pleasant and efficient process. KeyHunter helped to eliminate this gap and allowed me to collect relevant words that sell work on the stock again. In addition, it sorts the words by those that sold most often - and in descending order, which further improves the quality of word selection. I'm not one of those who gets a kick out of selecting keys for illustrations, but KeyHunter certainly makes this process easier and better.",
        user: {
            name: 'Юлія О.',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Russian',
        text: 'Thanks to KeyHunter, the work has become much faster! No need to rack your brains when selecting keys, everything is brought to automation. Sales have increased many times, it has become easier to select niches, I thank the whole team that made a very necessary and high-quality product for stockers!',
        user: {
            name: 'Дарья',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Ukrainian',
        text: 'Over the years of working on stocks, I have tried many tools for keyword selection. At the moment, KeyHunter is the best of all that I have worked with. It ensures the relevance, accuracy and consistency of the selected metadata, which allows you to significantly speed up and simplify the keying process. I recommend it to everyone who wants to increase the efficiency of their work!',
        user: {
            name: 'Вікторія Vik_Y',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Ukrainian',
        text: "I really liked KeyHunter. It sorts keys by importance, there is an opportunity to change their order, add your own words. Everything is implemented very conveniently. In addition to speeding up the work, it helps to find unique words that I would not have paid attention to myself. Another plus for me is that I myself choose works that are close to me in terms of visuals, the keys are collected from them, and not from the entire issue.",
        user: {
            name: 'Ксенія',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Russian',
        text: "I use it periodically, since I work periodically. But it is very convenient with a diverse portfolio. When you need to enter different niches. When you need to draw 10-20 works on the topic. When you need to draw 50 works on the niche - it allows you to find the most interesting options for similars. But I highly recommend using KeyHunter in conjunction with StockPerformer once every three to four months.",
        user: {
            name: 'Tetiana',
            role: 'Stocker',
        }
    },
    {
        translate: 'Translated from Russian',
        text: "I have used different keywords, but KeyHunter really collects and sorts fresh selling keys, which allows you to find a niche and get into it. It is very pleasing to see the growth of income! The interface is convenient, the guys are constantly improving it, listening to requests. Thank you for doing this for us!",
        user: {
            name: 'Виктория',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Russian',
        text: "I constantly use KeyHunter when uploading works, it significantly simplifies the selection of selling words. In addition, it helps to track what is in demand on stocks now. I can no longer imagine working without this tool!",
        user: {
            name: 'Mary',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Ukrainian',
        text: "An important component of success on the stock market is the keying of the work done. Using KeyHunter, I understand that I will describe my work as accurately and qualitatively as possible and, accordingly, I will get the maximum number of their downloads. KeyHunter is convenient to use and allows you to find keywords that, sometimes, I would not even guess, and these are additional sales. Therefore, I thank the developers for its creation and support.",
        user: {
            name: 'Віталій',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Russian',
        text: "I only use keyhunter to make keys, I can't even imagine how I can do without it! It's very convenient and easy to use. If there is a version for iPad, it will be really cool!",
        user: {
            name: 'Мария',
            role: 'Stocker',
        }
    },
    {
        translate: 'Translated from Russian',
        text: "The KeyHunter key cutter is very convenient and easy to use. I use only it in my work. All recommendations",
        user: {
            name: 'Olga R.',
            role: 'Illustrator',
        }
    },
    {
        translate: 'Translated from Russian',
        text: "I liked the KeyHunter keyword generator for its precise word selection, simple and clear interface. Before it, I tried several services, but I chose KeyHunter.",
        user: {
            name: 'Галина',
            role: 'Illustrator',
        }
    },
]